import { heroFeatured, siteStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-b from-background-100 via-background-50 to-background-50"
        aria-hidden="true"
      ></div>
      <div
        className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-primary-100/70 blur-3xl"
        aria-hidden="true"
      ></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6 pb-14 pt-10 md:pb-20 md:pt-16">
        <div className="grid items-start gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="animate-rise lg:col-span-5">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-50/80 px-3 py-1 font-label text-xs font-medium text-foreground-700">
              <i className="ri-flashlight-line text-primary-500" aria-hidden="true"></i>
              每周整理 · 紧跟更新节奏
            </span>

            <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-[42px] md:leading-[1.18]">
              日韩中文字幕
              <span className="text-primary-600">最新合集指南</span>
            </h1>

            <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              这里把日剧、韩剧、日韩电影与动画的中文字幕资源整理成清晰的榜单与合集：热门排行看口碑，
              编辑推荐看理由，分类浏览按题材速筛。片荒的时候，照着挑就够了。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#ranking"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-list-ordered" aria-hidden="true"></i>
                查看热门排行
              </a>
              <a
                href="#collections"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
              >
                <i className="ri-folder-2-line" aria-hidden="true"></i>
                浏览最新合集
              </a>
            </div>

            <div className="mt-7 flex flex-wrap gap-2">
              <a
                href="#picks"
                className="rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-xs font-medium text-foreground-700 hover:border-primary-200 hover:text-primary-700 cursor-pointer"
              >
                编辑精选
              </a>
              <a
                href="#browse"
                className="rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-xs font-medium text-foreground-700 hover:border-primary-200 hover:text-primary-700 cursor-pointer"
              >
                分类浏览
              </a>
              <a
                href="#guide"
                className="rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-xs font-medium text-foreground-700 hover:border-primary-200 hover:text-primary-700 cursor-pointer"
              >
                观看指引
              </a>
            </div>
          </div>

          <div className="animate-rise lg:col-span-7">
            <div className="mb-3 flex items-center justify-between">
              <p className="font-heading text-sm font-semibold text-foreground-800">
                今日口碑速览
              </p>
              <span className="font-label text-xs text-foreground-500">数据仅作选片参考</span>
            </div>
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:gap-4">
              {heroFeatured.map((item) => (
                <article
                  key={item.title}
                  className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 transition-colors hover:border-primary-200"
                >
                  <div className="flex items-start justify-between gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                      <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
                    </span>
                    <span className="flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-1 font-label text-xs font-semibold text-accent-800">
                      <i className="ri-star-fill text-accent-600" aria-hidden="true"></i>
                      {item.rating}
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-500">{item.meta}</p>
                  <p className="mt-3 border-t border-background-200 pt-3 text-xs text-foreground-700">
                    {item.note}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-3 md:mt-16 md:grid-cols-4 md:gap-4">
          {siteStats.map((stat) => (
            <div
              key={stat.label}
              className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-100/70 p-4"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-primary-600">
                <i className={`${stat.icon} text-lg`} aria-hidden="true"></i>
              </span>
              <div>
                <p className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
                  {stat.value}
                  <span className="ml-0.5 text-sm font-medium text-foreground-500">{stat.unit}</span>
                </p>
                <p className="text-xs text-foreground-600">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}